import type { IconData } from '@stacksjs/iconify-core'

export const pw4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGfySHge4h\"><path fill-opacity=\".7\" d=\"M-70.3 0h640v480h-640z\"/></clipPath></defs><g fill-rule=\"evenodd\" stroke-width=\"1pt\" clip-path=\"url(#SVGfySHge4h)\" transform=\"translate(70.3)\"><path fill=\"#4aadd6\" d=\"M-173.4 0h846.3v480h-846.3z\"/><path fill=\"#ffde00\" d=\"M335.6 232.1a135.9 130.1 0 1 1-271.7 0a135.9 130.1 0 1 1 271.7 0\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default pw4x3
